import React from "react"
import { useDispatch, useSelector } from "react-redux"
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"
import { useTheme } from "@material-ui/core/styles"
import { resetNotification } from "../../actions/notificationActions"

function Notification() {
	const { show, data, severity, duration } = useSelector((state) => state.notification)
	const dispatch = useDispatch()
	const theme = useTheme()

	const handleClose = () => {
		dispatch(resetNotification())
	}

	const styles = {
		snakbar: {
			marginTop: "64px",
		},
	}

	const Alert = React.forwardRef((props, ref) => {
		return (
			<MuiAlert {...props} ref={ref}>
				{data}
			</MuiAlert>
		)
	})

	const getTextColor = (severity) => {
		switch (severity) {
			case "info":
				return theme.palette.notificationText.info
			case "success":
				return theme.palette.notificationText.success
			case "error":
				return theme.palette.notificationText.error
			case "warning":
				return theme.palette.notificationText.warning
			default:
				return theme.palette.notificationText.default
		}
	}

	return show ? (
		<Snackbar
			style={styles.snakbar}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			open={show}
			autoHideDuration={duration || 5}
			onClose={handleClose}
		>
			<Alert
				elevation={6}
				variant="filled"
				onClose={handleClose}
				severity={severity}
				style={{
					color: getTextColor(severity),
					backgroundColor: severity === "error" ? theme?.palette?.errorNotification.main : undefined,
				}}
			/>
		</Snackbar>
	) : (
		<></>
	)
}

export default Notification
